<template lang="pug">
#modal-dinamica-laudos
    el-dialog.solicitar(
        :title='$t("mensagens.home.acessoRapido.botoes.SOLICITAR-LAUDO")',
        :visible.sync='showModal',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :before-close='fecharModal',
        :destroy-on-close='true'
    )
        .d-flex.laudo-margin
            SelecionarTipoLaudo(
                :laudoId='laudoId',
                @laudoUnico='atualizaLaudoUnico',
                @nomeComponenteSelecionado='atualizaNomeComponente'
            )
        component(
            :is='modalNome',
            @atualizarTerritoriosSelecionados='atualizarTerritoriosSelecionados',
            @voltar='voltar',
            :showModalOpcoes='showModalOpcoes',
            @showModalOpcoes='fecharModal',
            @showModalCarJaCadastrados='emitShowModalCarJaCadastrado',
            @showModalSelecionarTerritorios='fecharModal',
            @getLaudos='getLaudos'
        )
    el-dialog(
        :title='tituloConfirmarTerritorio',
        :visible.sync='showModalConfirmarTerritorios',
        close='changeShowModalConfirmarTerritorios',
        width='560px'
    )
        ConfirmarTerritorio(
            :selecionados='territoriosSelecionados',
            :tipoLaudo='tipoLaudo',
            @voltar='voltar'
        )
</template>

<script>
import SelecionarTipoLaudo from '@/modules/laudos/components/SelecionarTipoLaudo.vue';
import ConfirmarTerritorio from '@/modules/laudos/components/ConfirmarTerritorio.vue';
import EventBus from '@/utils/eventBus';

import LaudoGeralModal from '@/modules/laudos/views/selecaoVazia/LaudoGeralModal.vue';
import LaudoAvaliacaoFundiariasModal from '@/modules/laudos/views/avaliacaoFundiaria/LaudoAvaliacaoFundiariasModal.vue';
import LaudoAgricolaModal from '@/modules/laudos/views/agricola/LaudoAgricolaModal.vue';
import LaudoBacenFiscalizacaoModal from '@/modules/laudos/views/bacenFiscalizacao/LaudoBacenFiscalizacaoModal.vue';
import LaudoBenfeitoriasModal from '@/modules/laudos/views/benfeitorias/LaudoBenfeitoriasModal.vue';
import LaudoConformidadeAmbientalModal from '@/modules/laudos/views/conformidadeAmbiental/LaudoConformidadeAmbientalModal.vue';
import LaudoCarbonoModal from '@/modules/laudos/views/carbono/LaudoCarbonoModal.vue';
import LaudoHistoricoAgricolaModal from '@/modules/laudos/views/historicoAgricola/LaudoHistoricoAgricolaModal.vue';
import LaudoDiagnosticoAgricolaModal from '@/modules/laudos/views/diagnosticoAgricola/LaudoDiagnosticoAgricolaModal.vue';
import LaudoSupressaoVegetalModal from '@/modules/laudos/views/supressaoVegetal/LaudoSupressaoVegetalModal.vue';
import LaudoTecnicoAgricolaModal from '@/modules/laudos/views/tecnicoAgricola/LaudoTecnicoAgricolaModal.vue';
import LaudoCroquiModal from '@/modules/laudos/views/croqui/LaudoCroquiModal.vue';
import LaudoBacenResolucao140Modal from '@/modules/laudos/views/bacenResolucao140/LaudoBacenResolucaoModal.vue';
import LaudoAvaliacaoAreaProdutivaModal from '@/modules/laudos/views/avaliacaoAreaProdutiva/LaudoAvaliacaoAreaProdutivaModal.vue';
import LaudoAvaliacaoSocioambientalModal from '@/modules/laudos/views/avaliacaoSocioambiental/LaudoAvaliacaoSocioambientalModal.vue';
import LaudoDinamicaExploracaoModal from '@/modules/laudos/views/dinamicaExploracao/LaudoDinamicaExploracaoModal.vue';
import LaudoParceriaSustentavelRastreabilidadeModal from '@/modules/laudos/views/parceriaSustentavelRastreabilidade/LaudoParceriaSustentavelRastreabilidadeModal.vue';
import LaudoRenovabioModal from '@/modules/laudos/views/renovabio/LaudoRenovabioModal.vue';
import LaudoRelatorioTerritorialModal from '@/modules/laudos/views/relatorioTerritorial/LaudoRelatorioTerritorialModal.vue';
import LaudoAnaliseCoberturaSoloModal from '@/modules/laudos/views/analiseCoberturaSolo/LaudoAnaliseCoberturaSoloModal.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import LaudoSupressaoVegetalRedYellowFlagModal from '@/modules/laudos/views/supressaoVegetalRedYellowFlag/LaudoSupressaoVegetalRedYellowFlagModal.vue';

export default {
    name: 'ModalTipoLaudo',
    components: {
        SelecionarTipoLaudo,
        ConfirmarTerritorio,
        LaudoGeralModal,
        LaudoAvaliacaoFundiariasModal,
        LaudoAgricolaModal,
        LaudoBacenFiscalizacaoModal,
        LaudoBenfeitoriasModal,
        LaudoConformidadeAmbientalModal,
        LaudoCarbonoModal,
        LaudoHistoricoAgricolaModal,
        LaudoDiagnosticoAgricolaModal,
        LaudoSupressaoVegetalModal,
        LaudoTecnicoAgricolaModal,
        LaudoCroquiModal,
        LaudoBacenResolucao140Modal,
        LaudoAvaliacaoAreaProdutivaModal,
        LaudoAvaliacaoSocioambientalModal,
        LaudoDinamicaExploracaoModal,
        LaudoRenovabioModal,
        LaudoRelatorioTerritorialModal,
        LaudoAnaliseCoberturaSoloModal,
        LaudoParceriaSustentavelRastreabilidadeModal,
        LaudoSupressaoVegetalRedYellowFlagModal
    },
    props: {
        showModalSelecionarTerritorios: {
            type: Boolean,
            default: false
        },
        showModalOpcoes: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        showModalOpcoes(newValue) {
            if (newValue) {
                this.showModal = newValue;
            }
        },
        showModalSelecionarTerritorios(newValue) {
            if (newValue) {
                this.showModal = newValue;
                this.laudoId = this.laudoJaSelecionado;
            } else if (!newValue && !this.showModalConfirmarTerritorios) {
                this.laudoId = this.laudoJaSelecionado;
                this.showModalSelecionarTerritorios = false;
            }
        },
        showModalConfirmarTerritorios(newValue) {
            if (!newValue) {
                if (this.laudoJaSelecionado !== this.laudoId) {
                    this.laudoId = this.laudoJaSelecionado;
                    this.showModal = false;
                }
            }
        }
    },
    data() {
        return {
            modalNome: 'LaudoGeralModal',
            tipoLaudo: null,
            isLaudoUnico: false,
            laudoId: null,
            laudoJaSelecionado: null,
            tituloConfirmarTerritorio: null,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            showModal: this.showModalSelecionarTerritorios
        };
    },
    created() {
        EventBus.$off('laudo-selecionado');
        EventBus.$on('laudo-selecionado', laudoId => {
            if (this.laudoJaSelecionado === null) {
                this.laudoJaSelecionado = laudoId;
            }
            this.laudoId = laudoId;
        });
    },
    methods: {
        emitShowModalCarJaCadastrado(
            quantidadeCARs,
            laudosInfo,
            carsJaCadastrados
        ) {
            this.fecharModal();
            this.$emit(
                'showModalCarsJaEncontrados',
                quantidadeCARs,
                laudosInfo,
                carsJaCadastrados
            );
        },
        fecharModal() {
            this.showModal = false;
            this.$emit('setarFecharModalTipoLaudo');
        },
        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
            this.$emit('setarFecharModalTipoLaudo');
        },
        voltar() {
            this.changeShowModalConfirmarTerritorios();
        },
        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },
        atualizaNomeComponente(nomeComponente) {
            this.modalNome = nomeComponente;
            switch (this.modalNome) {
                case 'LaudoGeralModal':
                    this.tipoLaudo = null;
                    break;
                case 'LaudoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.AGRICOLA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoAgricola'
                    );
                    break;
                case 'LaudoAvaliacaoAreaProdutivaModal':
                    this.tipoLaudo = TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoAvaliacaoAreaProdutiva'
                    );
                    break;
                case 'LaudoAvaliacaoFundiariasModal':
                    this.tipoLaudo = TipoLaudo.AVALIACAO_FUNDIARIA;
                    break;
                case 'LaudoAvaliacaoSocioambientalModal':
                    this.tipoLaudo = TipoLaudo.AVALIACAO_SOCIOAMBIENTAL;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoDeAvaliacaoSocioambiental'
                    );
                    break;
                case 'LaudoDinamicaExploracaoModal':
                    this.tipoLaudo = TipoLaudo.DINAMICA_EXPLORACAO;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeDinamicaExploracao'
                    );
                    break;
                case 'LaudoParceriaSustentavelRastreabilidadeModal':
                    this.tipoLaudo =
                        TipoLaudo.PARCERIA_SUSTENTAVEL_RASTREABILIDADE;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoParceriaSustentavelRastreabilidade'
                    );
                    break;
                case 'LaudoSupressaoVegetalRedYellowFlagModal':
                    this.tipoLaudo =
                        TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoSupressaoVegetalRedYellowFlag'
                    );
                    break;
                case 'LaudoBacenFiscalizacaoModal':
                    this.tipoLaudo = TipoLaudo.BACEN_FISCALIZACAO;
                    break;
                case 'LaudoBacenResolucao140Modal':
                    this.tipoLaudo = TipoLaudo.BACEN_140;
                    break;
                case 'LaudoBenfeitoriasModal':
                    this.tipoLaudo = TipoLaudo.BENFEITORIAS;
                    break;
                case 'LaudoCarbonoModal':
                    this.tipoLaudo = TipoLaudo.CARBONO;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoCarbono'
                    );
                    break;
                case 'LaudoConformidadeAmbientalModal':
                    this.tipoLaudo = TipoLaudo.CONFORMIDADE;
                    break;
                case 'LaudoCroquiModal':
                    this.tipoLaudo = TipoLaudo.CROQUI_LOCALIZACAO;
                    break;
                case 'LaudoDiagnosticoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.DIAGNOSTICO_AGRICOLA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoDiagnosticoAgricola'
                    );
                    break;
                case 'LaudoHistoricoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.HISTORICO_AGRICOLA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoHistoricoAgricola'
                    );
                    break;
                case 'LaudoRenovabioModal':
                    this.tipoLaudo = TipoLaudo.RENOVABIO;
                    break;
                case 'LaudoSupressaoVegetalModal':
                    this.tipoLaudo = TipoLaudo.SUPRESSAO_VEGETAL;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoSupressaoVegetal'
                    );
                    break;
                case 'LaudoTecnicoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.TECNICO_AGRICOLA;
                    break;
                case 'LaudoRelatorioTerritorialModal':
                    this.tipoLaudo = TipoLaudo.RELATORIO_TERRITORIAL;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoRelatorioTerritorial'
                    );
                    break;
                case 'LaudoAnaliseCoberturaSoloModal':
                    this.tipoLaudo = TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO;
                    this.tituloConfirmarTerritorio = this.$t(
                        'laudos.solicitacaoDeLaudoAnaliseCoberturaDeSolo'
                    );
                    break;
            }
        },
        atualizarTerritoriosSelecionados(territoriosSelecionados) {
            this.territoriosSelecionados = territoriosSelecionados;
            this.changeShowModalConfirmarTerritorios();
            this.$emit('atualizarTerritoriosSelecionados');
        },
        async getLaudos() {
            this.$emit('getLaudos');
        }
    }
};
</script>

<style lang="scss">
#modal-dinamica-laudos {
    div.el-dialog__wrapper.solicitar div div.el-dialog__header {
        padding-bottom: 10px !important;
        background-color: var(--default-background-color);
        .el-dialog__title {
            font-weight: 600;
            color: var(--primary);
        }
    }
    .laudo-margin {
        margin-bottom: 10px;
    }
}
</style>
